import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-index"]
const _hoisted_2 = ["onClick", "innerHTML"]

import { computed, ref } from 'vue';
import { useVirtualizer } from '@tanstack/vue-virtual';
import AppCheckbox from '@/components/ui-kit/checkbox/AppCheckbox.vue';
import type { TagWithFrequency } from '@/models/interfaces/tags/tag-models';
import { escapeHtml, highlightSearchText } from '@/utils/textHelpers';

const ROW_ESTIMATE = 26;

type AppTagSelectorListProps = {
	tags: TagWithFrequency[];
	selectedIds: Set<number>;
	searchText?: string;
};

type AppTagSelectorListEmits = {
	toggle: [tag: TagWithFrequency];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTagSelectorList',
  props: {
    tags: {},
    selectedIds: {},
    searchText: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const listEl = ref<HTMLElement | null>(null);

const rowVirtualizer = useVirtualizer(computed(() => ({
	count: props.tags.length,
	getScrollElement: () => listEl.value,
	estimateSize: () => ROW_ESTIMATE,
	overscan: 8,
	getItemKey: (index: number) => props.tags[index]?.Id ?? index,
})));

const totalSize = computed<number>(() => rowVirtualizer.value.getTotalSize());

// При резкой смене данных (поиск, фоновое обновление списка) виртуализатор может
// на один тик отдать индексы от прежнего набора — такие строки отбрасываем,
// чтобы шаблон не читал tags[index] как undefined.
const visibleRows = computed(() => {
	return rowVirtualizer.value
		.getVirtualItems()
		.map((item) => ({ index: item.index, start: item.start, tag: props.tags[item.index] }))
		.filter((row) => !!row.tag);
});

const measureRow = (el: unknown) => {
	if (!el) {
		return;
	}
	rowVirtualizer.value.measureElement(el as HTMLElement);
};

const formatTagLabel = (tag: TagWithFrequency): string => {
	const name = highlightSearchText(props.searchText ?? '', escapeHtml((tag.Name ?? '').toLowerCase()));
	return `${name} (${tag.Frequency})`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "listEl",
    ref: listEl,
    class: "tag-list"
  }, [
    _createElementVNode("div", {
      class: "tag-list__spacer",
      style: _normalizeStyle({ height: `${totalSize.value}px` })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRows.value, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row.tag.Id,
          ref_for: true,
          ref: measureRow,
          "data-index": row.index,
          class: "tag-list__row",
          style: _normalizeStyle({ transform: `translateY(${row.start}px)` })
        }, [
          _createVNode(AppCheckbox, {
            style: { height: '16px', marginRight: '8px', marginTop: '1px' },
            value: _ctx.selectedIds.has(row.tag.Id),
            text: "",
            onOnInput: ($event: any) => (emit('toggle', row.tag))
          }, null, 8, ["value", "onOnInput"]),
          _createElementVNode("div", {
            class: "tag-list__text",
            onClick: ($event: any) => (emit('toggle', row.tag)),
            innerHTML: formatTagLabel(row.tag)
          }, null, 8, _hoisted_2)
        ], 12, _hoisted_1))
      }), 128))
    ], 4)
  ], 512))
}
}

})